export function styleFieldName(
  prefix: string | string[] | undefined,
  key: string,
): string | (string | number)[] {
  if (!prefix) return key;
  const parts = Array.isArray(prefix) ? prefix : [prefix];
  return [...parts, key];
}
